import React from "react";
import { Dialog, Pivot, PivotItem } from '@fluentui/react';
import SiteHistory from "./SiteHistory";
import MailsHistory from "./MailsHistory";


class SiteHistoryModal extends React.Component {


    
    render() {
        return (
            <div>
                { (!this.props.site) ? "":
                <Dialog
                hidden={!this.props.isModalOpened}
                onDismiss={this.props.onCloseModal}
                modalProps={{
                    isBlocking: false,
                    dragOptions: true
                }}
                dialogContentProps={{
                    title: `${this.props.site.title} history`
                }}
                minWidth={400}
                maxWidth={1000} >
                    <Pivot>
                        <PivotItem headerText="Site history">
                            <SiteHistory siteId={this.props.site.id} />
                        </PivotItem>
                        <PivotItem headerText="E-mails history">
                            <MailsHistory siteId={this.props.site.id} />
                        </PivotItem>
                    </Pivot>
            </Dialog>
                }
            </div>
        );
    }
}
export default SiteHistoryModal

// const closeIconStyles = {
//     root: {
//         float: 'right',
//         margin: '5px',
//         cursor: 'pointer'
//     }
// }

// const customStyles = {
//     content : {
//         top                   : '45%',
//         left                  : '50%',
//         right                 : 'auto',
//         bottom                : 'auto',
//         marginRight           : '-50%',
//         width                 : '1200px',
//         height                : '400px',
//         transform             : 'translate(-50%, -50%)',
//         background: 'white',
//         overflowX: 'hidden',
//         overflowY: 'auto',
//         border: 'thin solid lightgrey',
//         borderRadius: '0px'
//     }
// };





// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/SiteHistoryModal.js